$("#footer-newsletter").submit(function(){
  var footer_email= $('#footer-newsletter input[name="contact[email]"]').val();
  // if(window.logCustomer == true){
    
  //     var test1=Moengage.track_event("BSC-Footer-Email-Submit", {
  //       "email" : footer_email
  //     });
  //     console.log(test1);
    
  // }else{
  //      var test1=Moengage.add_unique_user_id(footer_email);
  //      var test2=Moengage.add_email(footer_email);
  //      var test3=Moengage.track_event("BSC-Footer-Email-Submit", {
  //       "email" : footer_email
  //     });
  //     console.log(test1,test2,test3); 
    
  // }
  
  // Moengage.track_event("BSC-Footer-Email-Submit", {
  //       "email" : footer_email
  // });
   
});  
$("#contest-newsletter").submit(function(){
// $("#contest-newsletter .btn_custom_false_1").click(function(){
  var contact_form_name= $('#contest-newsletter input[name="contact[name]"]').val();
  var contact_form_email= $('#contest-newsletter input[name="contact[email]"]').val();
  
  // var test=Moengage.track_event("BSC-TGC-Email-Submit", {
  //       "first_name":contact_form_name,
  //       "email" : contact_form_email
  // });  
     
  if(window.logCustomer == true){
       // Moengage.destroy_session();
       var test1=Moengage.add_unique_user_id(contact_form_email);
       var test2=Moengage.add_email(contact_form_email);
       var test3=Moengage.add_first_name(contact_form_name);
       var test=Moengage.track_event("BSC-TGC-Email-Submit", {
        "first_name":contact_form_name,
        "email" : contact_form_email
        });
      console.log(test1,test2,test3,test);
       console.log('==cutomerFirstname',cutomerFirstname)
       console.log('==cutomerEmail',customerEmail)
  }else{
       var test1=Moengage.add_unique_user_id(contact_form_email);
       var test2=Moengage.add_email(contact_form_email);
       var test3=Moengage.add_first_name(contact_form_name);
       var test=Moengage.track_event("BSC-TGC-Email-Submit", {
        "first_name":contact_form_name,
        "email" : contact_form_email
        });
      console.log("my_data",test1,test2,test3,test);
    
  }
    console.log('click');
    event.preventDefault();
    //toastr.success('You have been entered into our sweepstakes. Good luck!');  
    $('#contest-newsletter [name="contact[name]"]').val('');
    $('#contest-newsletter [name="contact[email]"]').val('');

    $('#contest-newsletter').hide();
    $('.footer-social-subscribe-block .subscribed_msg').show();
    localStorage.setItem("subscribe-block", "true");
 
 
  // alert("ok");
});
$(window).on('load', function () {
    var subscribeBlock = localStorage.getItem("subscribe-block");
    console.log('subscribeBlock',subscribeBlock);

    if(subscribeBlock == 'true')
    {
        $('#contest-newsletter').hide();
        $('.footer-social-subscribe-block .subscribed_msg').show();
    }
});
$(document).ready(function() {     
    if($('.logged').length > 0){
        var custemail = $('body').attr('data-customer-email');
        var custname = $('body').attr('data-customer-first-name');
        $('#contest-newsletter [name="contact[email]"]').val(custemail);
        $('#contest-newsletter [name="contact[name]"]').val(custname);
    }
   if(window.productInfo) {
    
     var product_price=parseFloat(productInfo.product_price.replace(",", ""));
     var myurl=window.location.href;
     var myArray = myurl.split("/");
    
     
     if(productInfo.product_title == productInfo.variants.title || productInfo.variants.title =="Default Title"){
        var Variant_Title="";
    }else{
        var Variant_Title=productInfo.variants.title;
    }
     var  product_collection = [];
       $.each(window.productInfo.collection_title1, function(key,val) {
          
           product_collection.push(val.title);
        });
    
      var BSC_Product_Viewed=  Moengage.track_event("BSC-Product-Viewed", {
        "Product Title" : productInfo.product_title,
        "Product ID" : productInfo.id,
        "Product Type" : productInfo.product_type,
        "Variant Title" : Variant_Title,
        "Variant ID" : productInfo.variants.id,
        "Product Collection" : product_collection.toString(), 
        "Product Vendor" : productInfo.product_vendor,
        "Product Url" : productInfo.product_url,
        "Product Image Url" : "https:"+productInfo.product_images[0],
        "Currency" : productInfo.currency,
        "Product Price" : product_price,
        "Source" : /Mobi/.test(navigator.userAgent) ? 'Mobile' : 'Desktop',
        });

     console.log("BSC_Product_Viewed",BSC_Product_Viewed);
    }
  
  if( window.collectionInfo) {
     
     //var mydate = moment();
     //var Event_Time=mydate.format("YYYY-MM-DDTHH:mm:ssZ");
       Moengage.track_event("BSC-Category-Viewed", {
        "Category Name" : collectionInfo.collection_title,
        "Category URL" : collectionInfo.collection_url,
        "Category Description" : collectionInfo.collection_description.replace( /(<([^>]+)>)/ig, ''),
        });
    }

  if( window.cartInfo) {
    
    if(cartInfo.customer_id != null){

          var Currency=""; 
           
          var Product_Title=[];
          var Product_Type=[];
          var Product_Collection=[];
          var Product_Vendor=[];
          var Product_ID=[];
          var Variant_ID=[];
                var Variant_Title=[]; 
          var Product_Url=[];
          var Product_Image_Url=[];
          var Product_Price=[];
          var Qty=[];
      
          var mymerge={};
        
        $.each(window.cartInfo.items, function(key,val) {
                 // Product_Title[key]=val.product_title;
              Product_Title.push(val.product_title);
              Product_Type.push(val.product_type);
              Product_Collection.push(val.collection.toString());
              Product_Vendor.push(val.vendor);
              Product_ID.push(val.product_id);
              Variant_ID.push(val.variant_id);
              Product_Url.push(val.product_url);
              Product_Image_Url.push("https:"+val.image);
              Product_Price.push(val.price);
              Qty.push(val.quantity);
              Currency=val.currency;
           if(val.variant_title =="Default Title"){ 
            Variant_Title.push(""); 
          }else{  
            Variant_Title.push(val.variant_title);  
          }
                    
          });
            // mymerge["Event Time"]=Event_Time;
            mymerge["Customer first name"]=cartInfo.customer_first_name;
            mymerge["Customer last name"]=cartInfo.customer_last_name;
            mymerge["Source"]=/Mobi/.test(navigator.userAgent) ? 'Mobile' : 'Desktop';
            mymerge["Currency"]=Currency;
            
            mymerge["Product Title"]=Product_Title;
            mymerge["Product Type"]=Product_Type;
            mymerge["Product Collection"]=Product_Collection;
            mymerge["Product Vendor"]=Product_Vendor;
            mymerge["Product ID"]=Product_ID;
            mymerge["Variant ID"]=Variant_ID;
            mymerge["Variant Title"]=Variant_Title;
            mymerge["Product Url"]=Product_Url;
            mymerge["Product Image Url"]=Product_Image_Url;
            mymerge["Product Price"]=Product_Price;
            mymerge["Qty"]=Qty;
            mymerge["Total Price"]=parseInt(cartInfo.total_price);
            
            
            var test_moe_checkout=Moengage.track_event("BSC-Checkout-Started",mymerge);
            // console.log(test); 
             console.log('merge',mymerge); 
              console.log('test_moe_checkout',test_moe_checkout); 
    }
    
  }
  
});
$(document).on('click','.Product__InfoWrapper .product-handle-button .ProductForm__AddToCart ',function(){
  
var product_price=parseFloat(productInfo.product_price.replace(",", ""));
       var myurl=window.location.href;
       var myArray = myurl.split("/"); 
       //var mydate = moment();
       //var Event_Time=mydate.format("YYYY-MM-DDTHH:mm:ssZ");
     
      
      var  product_collection = [];
       $.each(window.productInfo.collection_title1, function(key,val) {
           // console.log(val.handle);
           product_collection.push(val.title);
        }); 
        if(productInfo.product_title == productInfo.variants.title || productInfo.variants.title =="Default Title"){  
            var Variant_Title=""; 
        }else{  
            var Variant_Title=productInfo.variants.title; 
        }
  
       Moengage.track_event("BSC-Add-to-cart", {
        
        "Product Title" : productInfo.product_title,
        "Product ID" : productInfo.id,
        "Product Type" : productInfo.product_type,
        "Variant Title" : Variant_Title,
        "Variant ID" : productInfo.variants.id,
        "Product Collection" : product_collection.toString(),
        "Product Vendor" : productInfo.product_vendor,
        "Product Url" : productInfo.product_url,
        "Product Image Url" : "https:"+productInfo.product_images[0],
        "Currency" : productInfo.currency,
        "Product Price" : product_price,
        "Source" : /Mobi/.test(navigator.userAgent) ? 'Mobile' : 'Desktop',
      "Qty":1
        });   
  });